/**
 * Padel Scoring Validator
 * Enforces official Padel scoring regulations for match reporting.
 *
 * Single source of truth shared by the backend (API validation) and the
 * frontend (pre-submit UX validation).
 */
export const validateMatchScore = (sets) => {
    const invalidSets = [];
    let team1Wins = 0;
    let team2Wins = 0;
    // If no sets provided
    if (!sets || sets.length === 0) {
        return { isValid: false, error: "No scores entered." };
    }
    for (let i = 0; i < sets.length; i++) {
        const { pair1score, pair2score } = sets[i];
        const s1 = Number(pair1score);
        const s2 = Number(pair2score);
        // Rule A: Set Bounds (0-7)
        if (s1 < 0 || s2 < 0 || s1 > 7 || s2 > 7) {
            invalidSets.push(i);
            continue;
        }
        // Rule B: Winning Patterns
        let isValidPattern = false;
        // Standard win: 6-0, 6-1, 6-2, 6-3, 6-4 (and reverse)
        if ((s1 === 6 && s2 <= 4) || (s2 === 6 && s1 <= 4)) {
            isValidPattern = true;
        }
        // Tight set: 7-5 (and reverse)
        else if ((s1 === 7 && s2 === 5) || (s2 === 7 && s1 === 5)) {
            isValidPattern = true;
        }
        // Tie-break: 7-6 (and reverse)
        else if ((s1 === 7 && s2 === 6) || (s2 === 7 && s1 === 6)) {
            isValidPattern = true;
        }
        if (!isValidPattern) {
            invalidSets.push(i);
        }
        else {
            // Count wins for Rule C
            if (s1 > s2)
                team1Wins++;
            else if (s2 > s1)
                team2Wins++;
            else
                invalidSets.push(i); // Draws not allowed in final set scores
        }
    }
    if (invalidSets.length > 0) {
        return {
            isValid: false,
            error: "Invalid set score: A team must win by 2 games (e.g., 6-4) or win a tie-break (7-6).",
            invalidSets
        };
    }
    // Rule C: Match Conclusion
    // A match is won by the first team to win 2 sets.
    if (team1Wins >= 2 || team2Wins >= 2) {
        // Check for extra sets (e.g., 2-0 but 3 sets played)
        const setsNeeded = (team1Wins >= 2 && team2Wins === 0) || (team2Wins >= 2 && team1Wins === 0) ? 2 : 3;
        if (sets.length > setsNeeded) {
            // If the 3rd set is present but empty (0-0), we might ignore it in data collection,
            // but if it has scores, it's invalid.
            // Assuming the input `sets` only contains sets with actual values.
            return { isValid: false, error: "Match already decided. Set 3 should be empty." };
        }
    }
    else {
        // Match not finished (e.g. 1-1 or 1-0)
        return { isValid: false, error: "Match incomplete. One team must win 2 sets." };
    }
    return { isValid: true };
};
//# sourceMappingURL=validator.js.map